import React from "react";

export const Contact = (props) => {
  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-3 col-md-offset-0 contact-info">
            <div className="contact-item">
              <img
                src="img/marjan.jpg"
                className="img-padding"
                width="100px"
                alt=""
              />
              <br></br>
              <img src="img/fesb_logo.png" width="65px" alt="" />
              <img src="img/unist.png" width="38px" alt="" />
            </div>
          </div>
          <div className="col-md-3 col-md-offset-0 contact-info">
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Address
                </span>
                Rudjera Boskovica 32, 21000, Split
              </p>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-0 contact-info">
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>{" "}
                sikora@fesb.hr
              </p>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-0 contact-info">
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Telephone
                </span>{" "}
                ++385 (0)21 305-859
              </p>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>&copy; 2025 Marjan Sikora</p>
        </div>
      </div>
    </div>
  );
};
